import React, { type HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphMetrics as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphMetricsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphMetrics: React.FC<ParagraphMetricsProps> = ({
  id,
  entity,
}) => {
  const paragraphMetrics = entity.toJS();

  const title = paragraphMetrics.field_title[0]?.value;
  const body = paragraphMetrics.field_body[0]?.processed;
  const metricItems = paragraphMetrics.field_paragraphs;

  return (
    <div id={id} className="Paragraph ParagraphMetrics">
      <Container>
        <h2>{title}</h2>
        <WysiwygField html={body} />

        {metricItems.length > 0 && (
          <div className="ParagraphMetrics__subparagraphs">
            {metricItems.map((metricItem) => {
              const targetId = metricItem.target_id;

              return (
                <Paragraph
                  key={`paragraph:${targetId}`}
                  id={targetId}
                  entity={Immutable.fromJS(metricItem.entity)}
                />
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
};

export default ParagraphMetrics;
